import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 08CB23B7-EC19-4FE5-9CBB-C308CC89C10B
 * name reorder-horizontal
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/reorder-horizontal.svg
 * tags
 */
export const ReorderHorizontalIcon = createSvgIcon(<><path d="M3,15H21V13H3V15M3,19H21V17H3V19M3,11H21V9H3V11M3,5V7H21V5H3Z" /></>, 'ReorderHorizontalIcon');
export default ReorderHorizontalIcon